var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-card"},[_c('div',{class:['skeleton-card__block', _vm.size === 'small' ? 'small' : '']}),_c('div',{staticClass:"skeleton-card__block"})])}
var staticRenderFns = []

export { render, staticRenderFns }